import { notifications } from '@mantine/notifications';
import { api } from '~/trpc-extra/api';
import { useRouter } from 'next/router';
import { useProjectId } from '../context/useProjectId';
import { modals } from '@mantine/modals';
import { Title, Text } from '@mantine/core';

export function useCreateDraftAndPreview({ testContentId }: { testContentId: string }) {
  const router = useRouter();
  const projectId = useProjectId();

  const { mutateAsync: createDraftForTest, isPending } = api.testContent.fork.useMutation({
    onMutate: () => {
      notifications.show({ message: 'Creating a new draft copy...', color: 'gray' });
    },
    onSuccess: async (testDraft) => {
      await router.push({
        pathname: `/project/${projectId}/testDraft/${testDraft.id}`,
        query: { fromTest: true, preview: true },
      });
    },
    onError: (e) => {
      console.error(e);
      notifications.show({ message: 'Failed to create draft for editing', color: 'red' });
    },
  });

  const createDraftAndPreview = () => {
    modals.openConfirmModal({
      title: <Title order={4}>Start Preview</Title>,
      children: <Text>This will create a draft and start the preview.</Text>,
      labels: { confirm: 'Create Draft and Preview', cancel: 'Cancel' },
      centered: true,
      onConfirm: async () => await createDraftForTest({ testContentId }),
      confirmProps: {
        loading: isPending,
      },
    });
  };

  return createDraftAndPreview;
}
